export default __webpack_public_path__ + "static/media/clipart1236782.b5c76a88.png";